import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { TimelineEventSchema } from "./timeline";

export const TrackableEventType = [
  "ad",
  "upsell",
  "promotion",
  "subscription",
] as const;
export type TrackableEventType = (typeof TrackableEventType)[number];

export const TrackableBillingStatus = ["billed", "free"] as const;
export type TrackableBillingStatus = (typeof TrackableBillingStatus)[number];

//Because of circular dependencies I had to move it to its own file
export const ITrackableZodSchema = z.object({
  _id: zExt.objectId(),
  timeline: z.array(TimelineEventSchema),
  trackers: z
    .array(z.object({ _tracker: z.any(), fulfillmentID: z.string() }))
    .optional(),
  trackingTimeline: z.array(z.any()).optional(),
  trackingAnalytics: z
    .object({
      email: z.array(z.any()), //TODO: type this
      page: z.array(
        z.object({
          url: z.string(),
          eventType: createEnum(TrackableEventType, {
            enumName: "TrackableEventType",
          }),
          image: z.string().nullish(),
          createdAt: z.date(),
        }),
      ),
    })
    .optional(),
  trackingTextsSent: z
    .array(z.object({ sid: z.string(), mms: z.boolean(), sentAt: z.date() }))
    .nullish(),
  trackingEmailsSent: z
    .array(
      z.object({
        emailId: z.string(),
        status: z.string().optional(),
        sentAt: z.date().optional(),
        s3URL: z.string().nullish(),
        trigger: z.string().optional(),
        attachmentInfo: z
          .object({
            hasAttachments: z.boolean().optional(),
            attachmentCount: z.number().optional(),
            attachmentNames: z.array(z.string()).optional(),
          })
          .optional(),
        manuallySent: z.boolean().optional(),
      }),
    )
    .optional(),
  trackingWebhooksSent: z
    .array(
      z.object({
        destinationUrl: z.string(),
        sentAt: z.date(),
        automationStepId: z.string(),
        statusCode: z.number().optional(),
        success: z.boolean(),
        trigger: z.string(),
      }),
    )
    .nullish(),
  trackingBillingStatus: createEnum(TrackableBillingStatus, {
    enumName: "TrackingBillingStatus",
  }).nullish(),
  discount: z
    .object({
      id: z.string().nullish(),
      description: z.string().nullish(),
      code: z.string().nullish(),
      expirationDateTime: z.string().nullish(),
    })
    .optional(),
});
